import React, { FC } from 'react';

import { Box } from '@adsk/alloy-react-box';

import AttachmentListItemIconPlaceholder from './AttachmentFileHandlerIconPlaceholder';

type AttachmentFileHandlerThumbnailProps = {
  thumbnail?: string;
  onClick?: () => void;
};

const AttachmentFileHandlerThumbnail: FC<
  AttachmentFileHandlerThumbnailProps
> = ({ thumbnail, onClick }) => {
  return (
    <AttachmentListItemIconPlaceholder>
      {thumbnail ? (
        <Box
          data-testid="AttachmentFileHandlerThumbnail"
          style={{
            backgroundImage: `url(${thumbnail})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'pointer',
          }}
          onClick={onClick}
          borderRadius="4px"
          width="100%"
          height="100%"
        />
      ) : null}
    </AttachmentListItemIconPlaceholder>
  );
};

export default AttachmentFileHandlerThumbnail;
